/*
 * @FilePath: \kitchen-offline-web\src\3DEngine\callEngine\index.js
 * @Author: Yongchao Wang
 * @Date: 2021-08-18 17:53:06
 * @LastEditors: Yehao Gao
 * @LastEditTime: 2022-04-14 17:31:50
 */

import RenderVersion from '@/3DEngine/render/utils/renderVersion';
import {
  //  VOXTORPGLOBALNAME,
  VERSION_2_1,
} from '../render/utils/kitchenConfig';
import {
  existWindow,
  getHighFrame,
  setTopFramesHighFrame,
  // getDoors, getSidePlates,
  // getSealPlates, getDoorsAndHighFrameDoors, getCornerPlates,
} from './processedData';
import renderNoFrame from '../render/specialHandler/renderNoFrame';
import { toDomPos } from '../render/utils/renderUtils';
// import oldJson from '../render/H';
/**
 * @description: 调用引擎方法
 * @param {*} engine 3d引擎
  screenshot(callback) {
 * @param {*} calltype 类型 init 初始化,drawer 抽屉柜,door 门板,topPanel 台面,sink 水槽,handle 把手,highFrame 高柜,screenshot截屏,
    faucet水龙头、calloutLine 显隐标线、wall 墙面、ground 地面、window 窗户显隐、guideGif首页gif的位置和大小、stopRender停止渲染
 * @param {*} oldData 老的json、如果是显隐的type就是bool值
 * @param {*} newData 新的json
 * @return {*}
 * @author: Yongchao Wang
 */
export default function callEngine(engine, calltype, oldData, newData) {
  let type = calltype;
  // 如果是2.1以下老版本的数据直接重新 init
  if (
    typeof oldData === 'object'
    && oldData
    && RenderVersion.checkOldRenderVersion(oldData?.version, VERSION_2_1)
  ) {
    type = 'init';
  }

  return new Promise((resolve, reject) => {
    if ((!engine || !newData) && typeof oldData !== 'boolean') {
      reject();
    }

    const calculateGuide = (p1, p2) => { // 计算手势位置
      const point1 = toDomPos(p1, engine.scene, engine.camera, engine.engine);
      const point2 = toDomPos(p2, engine.scene, engine.camera, engine.engine);
      return {
        width: Math.abs(point1.x - point2.x),
        x: (point1.x + point2.x) / 2,
        y: (point1.y + point2.y) / 2,
      };
    };
    const shape = newData?.bottom?.type;
    console.log(shape);
    // const newTemplatejson = newData ? JSON.parse(JSON.stringify(oldJson)) : oldJson;
    // const newTemplatejson = newData;
    // const oldTemplatejson = oldData && JSON.parse(JSON.stringify(oldData));
    // 处理H型地柜 加高柜特殊处理
    let newTemplatejson = newData;
    // let oldTemplatejson = oldData && JSON.parse(JSON.stringify(oldData));
    newTemplatejson = newData ? renderNoFrame.checkNoFrames(newData) : newData;
    // oldTemplatejson = oldData ? renderNoFrame.checkNoFrames(oldData) : oldTemplatejson;
    switch (type) {
      case 'startRender':
        engine.startRender();
        break;
      case 'stopRender':
        engine.stopRender();
        break;
      case 'init':
      case 'drawer':
        engine.initConfig(newTemplatejson, () => {
          resolve({
            calloutLines: engine.calloutLineObj,
            existWindow: existWindow(newTemplatejson),
          });
        });
        break;

      case 'bottomDoor':
        // {
        //   // debugger;
        //   const newDoors = getDoors(newTemplatejson);
        //   const oldDoors = getDoors(oldTemplatejson);
        //   newDoors.top = [
        //     ...newDoors.top,
        //     ...getSidePlates(newTemplatejson).top,
        //     ...getSealPlates(newTemplatejson).top,
        //   ];
        //   newDoors.bottom = [
        //     ...newDoors.bottom,
        //     ...getSidePlates(newTemplatejson).bottom,
        //     ...getSealPlates(newTemplatejson).bottom,
        //     ...getCornerPlates(newTemplatejson),
        //   ];
        //   oldDoors.top = [
        //     ...oldDoors.top,
        //     ...getSidePlates(oldTemplatejson).top,
        //     ...getSealPlates(oldTemplatejson).top];
        //   oldDoors.bottom = [
        //     ...oldDoors.bottom,
        //     ...getSidePlates(oldTemplatejson).bottom,
        //     ...getSealPlates(oldTemplatejson).bottom,
        //     ...getCornerPlates(oldTemplatejson),
        //   ];
        //   let skirtingBoard;
        //   if (newTemplatejson?.bottom?.coverPlate?.componentBasic?.modelUrl
        //     !== oldTemplatejson?.bottom?.coverPlate?.componentBasic?.modelUrl) {
        //     skirtingBoard = newTemplatejson?.bottom?.coverPlate?.componentBasic?.modelUrl;
        //   }
        //   // TODO: 追求性能最佳的话，要判断如果有把手，需要将把手的mesh缓存下来，替换完门板重新add上去
        //   // 如果在有把手的情况下，从沃拓普切换到其他门板，或者反过来，都要重新渲染
        //   // DONE 转角柜补板换颜色已处理完成
        //   // const special = newTemplatejson?.bottom?.length1?.frames[0]?.width === 128
        //   // || newTemplatejson?.bottom?.length2?.frames[newTemplatejson?.bottom?.length2?.frames?.length - 1]?.width
        //   // === 128 || getSealPlates(newTemplatejson).bottom.length || getSealPlates(newTemplatejson).top.length;
        //   if (oldDoors.bottom[0].handle
        //     || ((newTemplatejson.bottom.globalName === 'VOXTORP 沃托普'
        //     || oldTemplatejson.bottom.globalName === 'VOXTORP 沃托普')
        //     && oldTemplatejson.bottom.globalName !== newTemplatejson.bottom.globalName
        //     && (oldDoors.bottom[0].handle || newDoors.bottom[0].handle || newDoors.highFrame10))
        //   ) {
        //     engine.initConfig(newTemplatejson, () => {
        //       resolve({ calloutLines: engine.calloutLineObj });
        //     });
        //   } else if (newTemplatejson.bottom.globalName === VOXTORPGLOBALNAME
        //   || oldTemplatejson.bottom.globalName === VOXTORPGLOBALNAME) {
        //     engine.changeDoorsWithVoxtorp(newTemplatejson, oldTemplatejson, () => {
        //       resolve();
        //     },
        //     skirtingBoard,
        //     'bottom');
        //     // engine.changeDoors(
        //     //   newTemplatejson,
        //     //   oldTemplatejson,
        //     //   { old: oldDoors.bottom, new: newDoors.bottom },
        //     //   { old: oldDoors.top, new: newDoors.top },
        //     //   () => {
        //     //     resolve();
        //     //   },
        //     //   skirtingBoard,
        //     // );
        //   } else {
        //     engine.changeDoors(
        //       newTemplatejson,
        //       oldTemplatejson,
        //       { old: oldDoors.bottom, new: newDoors.bottom },
        //       { old: oldDoors.top, new: newDoors.top },
        //       () => {
        //         resolve();
        //       },
        //       skirtingBoard,
        //     );
        //   }
        // }
        engine.initConfig(newTemplatejson, () => {
          resolve({ calloutLines: engine.calloutLineObj }, () => {
            resolve();
          });
        });
        break;
      case 'topDoor':
        // {
        //   const newDoors = getDoorsAndHighFrameDoors(newTemplatejson);
        //   newDoors.top = [
        //     ...newDoors.top,
        //     ...getSidePlates(newTemplatejson, 'top').top,
        //     ...getSealPlates(newTemplatejson).top,
        //   ];
        //   const oldDoors = getDoorsAndHighFrameDoors(oldTemplatejson);
        //   oldDoors.top = [
        //     ...oldDoors.top,
        //     ...getSidePlates(oldTemplatejson, 'top').top,
        //     ...getSealPlates(oldTemplatejson).top,
        //   ];
        //   // TODO: 追求性能最佳的话，要判断如果有把手，需要将把手的mesh缓存下来，替换完门板重新add上去
        //   // 如果在有把手的情况下，从沃拓普切换到其他门板，或者反过来，都要重新渲染
        //   const special = getSealPlates(newTemplatejson).top.length;
        //   if (oldDoors.top[0].handle
        //     || ((newTemplatejson.top.globalName === 'VOXTORP 沃托普'
        //     || oldTemplatejson.top.globalName === 'VOXTORP 沃托普')
        //     && oldTemplatejson.top.globalName !== newTemplatejson.top.globalName
        //     && (oldDoors.top[0].handle || newDoors.top[0].handle || newDoors.highFrame10)) || special) {
        //     engine.initConfig(newTemplatejson, () => {
        //       resolve({ calloutLines: engine.calloutLineObj });
        //     });
        //   } else if (newTemplatejson.bottom.globalName === VOXTORPGLOBALNAME
        //     || oldTemplatejson.bottom.globalName === VOXTORPGLOBALNAME) {
        //     engine.changeDoorsWithVoxtorp(newTemplatejson, oldTemplatejson, () => {
        //       resolve();
        //     },
        //     undefined,
        //     'top');
        //   } else {
        //     engine.changeDoors(
        //       newTemplatejson,
        //       undefined,
        //       undefined,
        //       { old: oldDoors.top, new: newDoors.top },
        //       () => {
        //         resolve();
        //       },
        //     );
        //   }
        // }
        engine.initConfig(newTemplatejson, () => {
          resolve({ calloutLines: engine.calloutLineObj }, () => {
            resolve();
          });
        });
        break;

      case 'topPanel':
        {
          const texture = newTemplatejson.bottom.topPanels[0].componentBasic.modelUrl;
          engine.changeTopPanelTexture(newTemplatejson, texture, () => {
            resolve();
          });
        }
        break;
      case 'sink':
        // {
        //   const oldSinkInfo = getSink(oldTemplatejson);
        //   const oldSink = oldSinkInfo.sink;
        //   const { edge } = oldSinkInfo;
        //   const newSink = getSink(newTemplatejson).sink;
        //   // TODO： 如果水槽长宽不一样需要重新挖洞
        //   if (oldSink && newSink
        //     && newSink.componentBasic.width === oldSink.componentBasic.width
        //     && newSink.componentBasic.depth === oldSink.componentBasic.depth) {
        //     engine.changeSink(newTemplatejson, oldSink, newSink, edge, () => {
        //       resolve();
        //     });
        //   } else {
        //     engine.initConfig(newTemplatejson, () => {
        //       resolve({ calloutLines: engine.calloutLineObj }, () => {
        //         resolve();
        //       });
        //     });
        //   }
        // }
        engine.initConfig(newTemplatejson, () => {
          resolve({ calloutLines: engine.calloutLineObj }, () => {
            resolve();
          });
        });
        break;
      case 'handle':
        // const oldHandle = getHandles(oldTemplatejson);
        // const newHandle = getHandles(newTemplatejson);
        // if (oldHandle.bottom[0]) {
        //   engine.changeHandle(
        //     newTemplatejson,
        //     { old: oldHandle.bottom, new: newHandle.bottom },
        //     { old: oldHandle.top, new: newHandle.top },
        //     () => {
        //       resolve();
        //     },
        //   );
        // } else {
        // 把手角度较为特殊，需要重新渲染，后期可以优化
        engine.initConfig(newTemplatejson, () => {
          resolve({ calloutLines: engine.calloutLineObj });
        });
        // }

        break;
      case 'highFrame':
        {
          const newHighFrame = getHighFrame(newTemplatejson);
          const newJson = setTopFramesHighFrame(
            JSON.parse(JSON.stringify(newTemplatejson)),
            newHighFrame,
          );
          engine.initConfig(newJson, () => {
            resolve({ calloutLines: engine.calloutLineObj });
          });
        }

        break;

      case 'screenshot':
        engine.screenshot((image) => {
          resolve({ image });
        });
        break;
      case 'faucet':
        engine.initConfig(newTemplatejson, () => {
          resolve({ calloutLines: engine.calloutLineObj });
        });
        break;
      case 'calloutLine':
        engine?.changeCalloutLinesVisible(oldData);
        resolve();
        break;
      case 'wall':
        {
          const wallInfo = newTemplatejson.other.wall;
          engine.changeWall(wallInfo);
          resolve();
        }
        break;
      case 'ground':
        {
          const floorInfo = newTemplatejson.other.floor;
          engine.changeGround(floorInfo);
          resolve();
        }
        break;
      case 'window':
        {
          const show = oldData;
          engine.showWindow(show);
          resolve(show);
        }
        break;
      case 'room': {
        const show = oldData;
        engine?.showRoom(show);
        resolve(show);
      }
        break;
      case 'guideGif':
        switch (shape) {
          case 'L':
            {
              const p1 = { x: -210 / 100, y: 0, z: 60 / 100 };
              const p2 = { x: -60 / 100, y: 0, z: 160 / 100 };
              resolve(calculateGuide(p1, p2));
            }
            break;
          case 'I':
            {
              const p1 = { x: -210 / 100, y: 0, z: 65 / 100 };
              const p2 = { x: -30 / 100, y: 0, z: 65 / 100 };
              resolve(calculateGuide(p1, p2));
            }
            break;
          case 'H':
            {
              const p1 = { x: -240 / 100, y: 0, z: 40 / 100 };
              const p2 = { x: -240 / 100, y: 0, z: 200 / 100 };
              resolve(calculateGuide(p1, p2));
            }
            break;
          case 'U':
            {
              const p1 = { x: -240 / 100, y: 0, z: 40 / 100 };
              const p2 = { x: -240 / 100, y: 0, z: 190 / 100 };
              resolve(calculateGuide(p1, p2));
            }
            break;
          default:
            break;
        }

        break;
      default:
        break;
    }
  });
}
